export interface TranslatableGenre {
  name: string
  name_pt?: string | null
  name_en?: string | null
  name_es?: string | null
}

export function getTranslatedGenreName(genre: TranslatableGenre, language: string): string {
  switch (language) {
    case 'pt':
    case 'pt-BR':
      return genre.name_pt || genre.name_en || genre.name
    case 'es':
    case 'es-ES':
      return genre.name_es || genre.name_en || genre.name
    default:
      return genre.name_en || genre.name
  }
}
